export const hotelDetailRoute = (hotelAlias: string, search: string, subpage?: string, ) => {
    const subpageWithDash = subpage ?  '/' + subpage : '';
    return `/hotels/${hotelAlias}${subpageWithDash}${search}`;
}
